import { cmsCLient } from '@/services/axiosConfig'
import { GetServiceBranches } from './types'

export const getServiceBranches: GetServiceBranches = async (params) => {
  try {
    const response = await cmsCLient.get('/branch/list', { params })
    return response.data.data
  } catch (e: any) {
    return e.message
  }
}
